import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { HelpComponent } from '../help.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-help-home',
  standalone: true,
  templateUrl: './help-home.component.html',
  styleUrls: ['./help-home.component.css'],
})
export class HelpHomeComponent {
  readonly parent = input.required<HelpComponent>();
}
